import fetch from '@giro/shared-utils/fetch.util';

export default async function postApiTerminalsRegistrationsService(
  body: any = {}
) {
  return fetch('terminals/registrations', {
    method: 'POST',
    ms: 'PDV',
    auth: true,
    body: JSON.stringify(body),
  });
}
